import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { usePermissions } from "../../../../auth/PermissionProvider";
import { Permissions } from "../../../../auth/permissions";
import { AcessoPerfil } from "../../../../interfaces/acessos";
import { getPerfisAcesso } from "../../../../services/acessosApi";
import { BTN_SECUNDARIO, Carregando, Erro, Vazio } from "../../paineis-admin/components/shared";

/** Perfis que dá para atribuir nesta organização (lista já filtrada pelo backend). */
const PerfisTab: React.FC<{ orgId: number }> = ({ orgId }) => {
  const { can } = usePermissions();
  const [perfis, setPerfis] = useState<AcessoPerfil[]>([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(false);

  const carregar = useCallback(async () => {
    setLoading(true);
    try {
      setPerfis(await getPerfisAcesso(orgId));
      setErro(false);
    } catch {
      setErro(true);
    } finally {
      setLoading(false);
    }
  }, [orgId]);

  useEffect(() => {
    carregar();
  }, [carregar]);

  if (loading) return <Carregando rotulo="Carregando perfis" />;
  if (erro) return <Erro texto="Não foi possível carregar os perfis. Tente de novo." onTentar={carregar} />;

  return (
    <section aria-label="Perfis atribuíveis" className="space-y-4">
      {can(Permissions.ProfilesManage) && (
        <div className="flex justify-end">
          <Link to="/admin/profiles" className={BTN_SECUNDARIO}>
            Editar perfis
          </Link>
        </div>
      )}
      {perfis.length === 0 ? (
        <Vazio texto="Nenhum perfil pode ser concedido nesta organização por você. Os perfis que você pode atribuir aparecerão aqui." />
      ) : (
        <ul className="grid gap-3 sm:grid-cols-2">
          {perfis.map((p) => (
            <li
              key={p.id}
              className="rounded-2xl border border-gray-100 bg-white p-4 shadow-dv-md dark:border-white/10 dark:bg-navy-800 dark:shadow-none"
            >
              <p className="font-display text-base font-bold text-navy-700 dark:text-white">{p.nome}</p>
              <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">{p.descricao || "Sem descrição."}</p>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};

export default PerfisTab;
